import { useMutation, useQueryClient } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IAssignUserFavoriteParams } from "../../services/ui-personalization-data-service/Models";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys } from "./Keys";

export type UseAssignUserFavoriteParameters = {
    groupID: number;
} & BaseUseMutationParameters<void, IAssignUserFavoriteParams>;

export function useAssignUserFavorite({
    groupID,
    onError,
    onSuccess
}: UseAssignUserFavoriteParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, IAssignUserFavoriteParams>(
        (model) => {
            return UIPersonalizationDataService.assigntUserFavorite(groupID, model);

        },
        {
            onMutate: async (model: IAssignUserFavoriteParams) => {

                await queryClient.cancelQueries(keys.all);

                await queryClient.invalidateQueries(keys.all, {
                    active: true,
                    inactive: true
                });

                return {
                    previous: model
                };

            },
            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _favorite, context) => {

                // if (error && context?.previousFavorites) {
                //     queryClient.setQueryData<Array<IUIUserFavoriteModel>>(
                //         keys.favoriteList(),
                //         context?.previousFavorites
                //     );
                // }

                if (!error) {
                    queryClient.invalidateQueries(keys.favoriteList());
                }
            }
        }
    );
}
